import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';


export const BhpButton = styled(Button)({
    backgroundColor: '#e65400',
    color: 'white',
    '&:hover': {
        backgroundColor: '#cc4700'
    }
});